import { useContext } from 'react'

import { PermissionsContext } from './permissionsContext'

export const usePermissionsContext = () => {
  const context = useContext(PermissionsContext)

  if (!context)
    throw new Error(
      'You forgot to wrap your component in <PermissionsContextProvider>',
    )

  return context
}
